import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type NewUser = {
  first_name: string;
  last_name: string;
  email: string;
  kyc_program_id: number | null;
  phone: string;
  country: string;
  citizenship_country: string;
  user_birth_date: string;
  gender: string;
  password: string | null;
  currency: string;
  city: string;
  address: string;
  state: string;
  zip_code: string;
  form1_json: string | null;
  form3_json: string | null;
  form4_json: string | null;
};

type RegisterState = {
  newUser: NewUser | null;
};

const initialState: RegisterState = {
  newUser: null,
};

export const registerSlice = createSlice({
  name: "register",
  initialState,
  reducers: {
    setNewUser: (state, action: PayloadAction<NewUser | null>) => {
      state.newUser = action.payload;
    },
  },
});

export const { setNewUser } = registerSlice.actions;
